// extracted by mini-css-extract-plugin
export default {"result":"FtMlnDEM4CpKYUMrFfLA","text":"ipWGgEXhQPB9ljxbbMmz","number":"tcnpMzeuUPNm9nWLoh7T"};